import { InjectionToken } from '@angular/core';

import { WrapperVersion } from '../models/wrapper-version.model';

export const WRAPPER_VERSION = new InjectionToken<WrapperVersion>('WRAPPER_VERSION');
